import React from "react";
import Typography from "@mui/material/Typography";

import { TaskTemplateReference } from "@/interfaces/ITaskTemplates";

/** Names the template a task was created from, when it has one. */
function TemplateOrigin({ template }: { template?: TaskTemplateReference }) {
  if (!template?.title) return null;

  return (
    <Typography sx={{ fontSize: "13px", color: "#6b7280", mt: 1 }}>
      Created from template: <strong>{template.title}</strong>
    </Typography>
  );
}

export default TemplateOrigin;
